import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import { useNavigate, useParams, useLocation  } from "react-router-dom";
import { TiEdit,TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import { FcPlus } from "react-icons/fc";
import { Container, Row, Col, Button, Stack } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import moment from "moment";
import { toast } from "react-toastify";

import { useAuthContext } from "../../contexts/AuthContext";
import SupplierDataService from "../../services/supplier.service";
// import ReactTooltip from "react-tooltip";
// import { TiEdit, TiDeleteOutline, TiEyeOutline } from "react-icons/ti";

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import "./Supplier.scss";

const perPage = 10;

function Suppliers() {

  let { projectId } = useParams();

  const aggridRef = useRef();

  const navigate = useNavigate();
  const { user, setIsLoading } = useAuthContext();

  const [supplierList, setSupplierList] = useState([]);
  const [pageSize, setPageSize] = useState();

  useEffect(() => {
    if(user){
      retrieveSupplierDetails();
    }
  }, [user, projectId])

  useEffect(() => {
    const supplierId = supplierList.map((item) => item.id);
    console.log('supplierId', supplierId);
  }, [supplierList])
  

  function retrieveSupplierDetails() {
    setIsLoading(true);
    SupplierDataService.getByProject(projectId).then((response) => {
      setIsLoading(false);
      setSupplierList([...response.data.data]);
    });
  }

  console.log('retrieveSupplierDetails');
  

  function deleteSupplier(id) {
    console.log('delete', id);

    let suppList = [...supplierList];

    const updatedSupplier = suppList.filter((item) => item.id !== id);
    setSupplierList([...updatedSupplier]);
    // const updatedsupplierId = updatedSupplier.map((item) => item.id);
    // console.log('updatedsupplierId', updatedsupplierId);

    // SupplierDataService.delete(id).then((response) => {
    //   if(response.data.success){
    //     const updatedSupplier = supplierList.filter((item) => item.id !== id);
    //     setSupplierList(updatedSupplier);
    //     toast.error("Supplier Deleted!");
    //   } else {
    //     toast.error("Error in deleting supplier");
    //   }
    // });
  }

  function onPageSizeChanged(e) {
    let value = e.target.value;
    setPageSize(value);
    aggridRef.current.api.paginationSetPageSize(Number(value));
  };

  const columnDefs = [
      {headerName: "Supplier Name", field: "supplierName", filter: true, sortable:true, width:"280"},
      {headerName: "Suppliper Code", field: "supplierCode",filter: true, sortable:true, width:"150"},
      {headerName: "ERP", field: "supplierERP",filter: true,  sortable:true, width:"250"},
      {headerName: "File Location", field: "supplierFileLocation",filter: true,  sortable:true, width:"140",
        cellRendererFramework: (data) => {
          return (data.value ? 'YES' : 'NO') 
        }
      },
      {headerName: "Modified By", field: "modifiedBy.name",filter: true,  sortable:true, width:"120",
        cellRendererFramework: (data) => {
          return (!data.value ? "admin" :  data.value)
          } 
      },
      {headerName: "Updated At", field: "updatedAt",filter: true,  sortable:true, width:"160",
        cellRendererFramework: (data) => {
            return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
          } 
      },
      {headerName: "Action", field:"id", width:"120",
        cellRendererFramework: (data) => {
           return <>
                <Link title="Details" className="text-primary mr-4 margin-right" to={"/project/"+projectId+"/supplier/"+data.value+"/detail"}><TiEyeOutline  size="25" /></Link>
                <Link title="Edit" className="text-success mr-2 margin-right" to={"/project/"+projectId+"/supplier/"+data.value+"/edit"}><TiEdit  size="25" /></Link>
                {user && user?.role === "superadmin" && (
                  <span className="text-danger cursor-pointer" title="delete" onClick={() => deleteSupplier(data.value)}><TiDeleteOutline size="25" /></span>
                )}
            </>
        }
        
      }
    ];

  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}><h1 className="mt-4 pageTitle">Suppliers List</h1></Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={1}>
            <Button variant="primary" className="mt-4" onClick={() => navigate(`/project/${projectId}/supplier/create`)}><FcPlus /> Create Supplier</Button>
          </Stack>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
            {supplierList && supplierList.length > 0 ? (
              <div className="example-header">
                Page Size: &nbsp;
                <select onChange={onPageSizeChanged} id="page-size" value={pageSize}>
                  <option value="10">
                    10
                  </option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>
            ) : (
              <h6>No supplier Found</h6>
            )}
            {supplierList && supplierList.length > 0 && projectId && (
              <AgGridReact
                  ref={aggridRef}
                  pagination={true}
                  rowHeight={50}
                  paginationPageSize={perPage}
                  columnDefs={columnDefs}
                  rowData={supplierList}>
              </AgGridReact>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Suppliers;
